import { render, staticRenderFns } from "./checkoutV3.vue?vue&type=template&id=2caed2ab&scoped=true"
import script from "./checkoutV3.vue?vue&type=script&lang=js"
export * from "./checkoutV3.vue?vue&type=script&lang=js"
import style0 from "./checkoutV3.vue?vue&type=style&index=0&id=2caed2ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caed2ab",
  null
  
)

export default component.exports